// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__21voA","options":"AnswerScale_options__3zza7","selected":"AnswerScale_selected__1RKel"};